import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { PricingSection } from './PricingSection';
import { UrgencyTimer } from './UrgencyTimer';
export function FinalCTA() {
  return <section className="bg-slate-900 pb-20" data-id="element-108">
      <UrgencyTimer data-id="element-109" />
      <PricingSection data-id="element-110" />

      <div className="max-w-3xl mx-auto px-4 mt-8" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-wrap justify-center gap-6 md:gap-8 text-sm md:text-base font-medium text-slate-400 bg-slate-800/50 py-6 px-4 rounded-2xl border border-slate-700/50" data-id="element-112">
          <span className="flex items-center gap-2" data-id="element-113">
            <Lock className="w-5 h-5 text-slate-300" data-id="element-114" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-115">
            <Zap className="w-5 h-5 text-amber-400" data-id="element-116" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-117">
            <Shield className="w-5 h-5 text-green-400" data-id="element-118" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-119">
            <CreditCard className="w-5 h-5 text-blue-400" data-id="element-120" /> Mercado Pago |
            Tarjeta | Transferencia
          </span>
        </motion.div>
      </div>
    </section>;
}